import { useEffect } from "react"
import { usePage } from "@inertiajs/react"
import { toast } from "@/components/ui/sonner"

// Bridges Rails' flash to sonner toasts.
//
// `inertia_rails` shares the flash automatically on the
// page object (`usePage().flash`, NOT inside `props`), with
// the default allowed keys `notice` and `alert`. These keys
// bypass the `prop_transformer`, so they stay snake_case-free
// plain `notice` / `alert` strings.
//
// `notice` → success toast, `alert` → error toast. The
// effect keys on the two values so it fires once per flash
// and not on every render. Mounted ONCE in `DefaultLayout`
// alongside the <Toaster>.
export function FlashToasts() {
  const page = usePage()
  const flash = page.flash as
    | { notice?: string; alert?: string }
    | undefined

  const notice = flash?.notice
  const alert = flash?.alert

  useEffect(() => {
    if (notice) toast.success(notice)
  }, [notice])

  useEffect(() => {
    if (alert) toast.error(alert)
  }, [alert])

  return null
}
